import { DialogComponent } from '@theme/dialog';

const HASH = '#be-booking-overlay';
const TRIGGER_SELECTOR = `a[href$="${HASH}"]`;

/**
 * The booking overlay (blocks/booking-overlay.liquid): a hidden, pre-rendered
 * dialog holding the NowBookIt embed — one instance per page.
 *
 * Opens from three kinds of trigger:
 * - on-page `on:click="#be-booking-overlay/showDialog"` buttons (the hero
 *   sub-nav's sentinel link, or the block's own trigger button);
 * - any anchor whose href ends in `#be-booking-overlay`, followed in place of
 *   navigating — so plain link blocks work on pages that have the overlay;
 * - a `#be-booking-overlay` URL hash on load, making e.g.
 *   /pages/restaurant#be-booking-overlay a deep link that works from pages
 *   without the overlay. The hash is stripped once consumed so a refresh
 *   after closing doesn't reopen it.
 */
class BookingOverlayComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();

    document.addEventListener('click', this.#handleTriggerClick);
    this.#openFromHash();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('click', this.#handleTriggerClick);
  }

  #openFromHash() {
    if (window.location.hash !== HASH) return;

    history.replaceState(null, '', window.location.pathname + window.location.search);
    this.showDialog();
  }

  /**
   * Opens the overlay in place of following a trigger link.
   *
   * @param {MouseEvent} event - The click event.
   */
  #handleTriggerClick = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const link = target?.closest(TRIGGER_SELECTOR);

    if (!link || this.contains(link)) return;

    event.preventDefault();
    this.showDialog();
  };
}

if (!customElements.get('be-booking-overlay-component')) {
  customElements.define('be-booking-overlay-component', BookingOverlayComponent);
}
